<template>
  <div class="filter-content-wrapper">
    <!--Small Screen-->
    <template v-if="smallScreen">
      <stickyelement>
        <div class="filter-bar">
          <span class="filters-title">
            {{ productDataset.filter_data.filter_title }}
            <span class="filter-results-count">({{ productDataset.results }})</span>
          </span>
          <button class="filter-button" @click.prevent="openSidebarFilter()">
            <svg class="icon">
              <title>filter button</title>
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-filter"></use>
            </svg>
            <span class="label">{{ productDataset.filter_data.Mobile_Filter }}</span>
          </button>
        </div>
      </stickyelement>

      <div class="sidebar-wrapper-filter" :class="{ toggled: sidebarFilterShown }">
        <div class="sidebar-wrapper">
          <div class="filters">
            <div class="filter-header" :class="{ 'filter-header-fixed': filterHeaderFixed }">
              <span class="filters-title">
                {{ productDataset.filter_data.filter_title }}
                <span class="filter-results-count">({{ productDataset.results }})</span>
              </span>
              <p v-if="productDataset.show_clear_filters" class="filters-clear">
                <a
                  v-tag="productDataset.filter_data.tagging_attributes_clear_filters"
                  href="#"
                  @click.prevent="
                    filterProducts(
                      productDataset.clear_filter_api_url,
                      productDataset.clear_filter_url,
                    )
                  "
                >
                  {{ productDataset.filter_data.clear_filters }}</a
                >
              </p>
              <button class="sidebar-close-filters" @click.prevent="closeSidebarFilter()">
                <svg class="icon">
                  <title>close filter button</title>
                  <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#close-sidebar-filters"
                  ></use>
                </svg>
              </button>
            </div>

            <template
              v-for="(filter_collection, index) in productDataset.filters"
              :key="`section-${index}`"
            >
              <div
                :ref="`section-${index}`"
                class="filter-section"
                :class="{ 'filter-section--hidden': sidebarFilterShown }"
              >
                <div
                  :ref="`trigger-${index}`"
                  class="filter-section--header"
                  tabindex="0"
                  aria-expanded="false"
                  role="button"
                  @click.prevent="handleClick(index)"
                  @focus="handleFocus(index)"
                  @focusout="handleFocusOut(index)"
                >
                  <h2 class="filter-section--header--title">{{ filter_collection.title }}</h2>
                  <span class="filter-section--header--status"></span>
                </div>
                <div
                  :ref="`collapsable-${index}`"
                  class="filter-section--list-wrapper"
                  aria-hidden="true"
                >
                  <ul class="filter-section--list">
                    <li
                      v-for="filter in filter_collection.filters"
                      :key="filter.id"
                      :class="{
                        'is-with-color': filter.color,
                        'is-filter-disabled': filter.disabled,
                        'is-filter-selected': filter.selected,
                      }"
                    >
                      <span
                        v-if="filter.color"
                        class="filter-section--color"
                        :style="{ 'background-color': filter.color }"
                      ></span>
                      <span
                        v-if="filter.filtertitle && filter.filtertitle !== ' '"
                        class="checkbox"
                        @click="sendDataTrackingAjax"
                      >
                        <span
                          :class="{ 'is-ref-tag-attributes': filter.selected }"
                          class="is-attributes-hidden"
                          :data-title="filter_collection.title"
                          >{{ filter }}</span
                        >
                        <input
                          :id="filter.id"
                          type="checkbox"
                          :disabled="filter.disabled"
                          :checked="filter.selected"
                          @change="
                            filterProducts(filter.url_to_api_with_params, filter.url_to_show)
                          "
                        />
                        <label :for="filter.id">{{ filter.filtertitle }}</label>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </div>
        </div>
        <overlay></overlay>
      </div>
    </template>
    <!--/Small Screen-->

    <!--Big screen-->
    <template v-if="!smallScreen">
      <div v-sticky-filters class="filter-wrapper">
        <div class="filters">
          <div class="filter-header">
            <span class="filters-title">
              {{ productDataset.filter_data.filter_title }}
              <span class="filter-results-count">({{ productDataset.results }})</span>
            </span>
            <p v-if="productDataset.show_clear_filters" class="filters-clear">
              <a
                href="#"
                @click.prevent="
                  filterProducts(
                    productDataset.clear_filter_api_url,
                    productDataset.clear_filter_url,
                  )
                "
              >
                {{ productDataset.filter_data.clear_filters }}</a
              >
            </p>
          </div>

          <template
            v-for="(filter_collection, index) in productDataset.filters"
            :key="`section-${index}`"
          >
            <div :ref="`section-${index}`" class="filter-section">
              <div
                :ref="`trigger-${index}`"
                class="filter-section--header"
                tabindex="0"
                aria-expanded="true"
                role="button"
                @click.prevent="handleClick(index)"
                @focus="handleFocus(index)"
                @focusout="handleFocusOut(index)"
              >
                <h2 class="filter-section--header--title">{{ filter_collection.title }}</h2>
                <span class="filter-section--header--status"></span>
              </div>
              <div
                :ref="`collapsable-${index}`"
                class="filter-section--list-wrapper"
                aria-hidden="false"
              >
                <ul class="filter-section--list">
                  <li
                    v-for="filter in filter_collection.filters"
                    :key="filter.id"
                    :class="{
                      'is-with-color': filter.color,
                      'is-filter-disabled': filter.disabled,
                      'is-filter-selected': filter.selected,
                    }"
                  >
                    <span
                      v-if="filter.color"
                      class="filter-section--color"
                      :style="{ 'background-color': filter.color }"
                    ></span>
                    <span
                      v-if="filter.filtertitle && filter.filtertitle !== ' '"
                      class="checkbox"
                      @click="sendDataTrackingAjax"
                    >
                      <span
                        :class="{ 'is-ref-tag-attributes': filter.selected }"
                        class="is-attributes-hidden"
                        :data-title="filter_collection.title"
                        >{{ filter }}</span
                      >
                      <input
                        :id="filter.id"
                        type="checkbox"
                        :disabled="filter.disabled"
                        :checked="filter.selected"
                        @change="filterProducts(filter.url_to_api_with_params, filter.url_to_show)"
                      />
                      <label :for="filter.id">{{ filter.filtertitle }}</label>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <!--/Big screen-->
  </div>
</template>

<script>
export default {
  name: 'filters',
  props: {
    productDataset: { type: Object, required: true },
  },
  data() {
    return {
      index: 0,
      sidebarFilterShown: false,
      filterHeaderFixed: false,
      activeTab: '',
      isActive: false,
      smallScreen: window.ScreenSizeHandler
        ? window.ScreenSizeHandler.getMqForSize('small').selected
        : true,
      activeSection: null,
      activeTrigger: null,
      activeCollapsable: null,
    };
  },
  watch: {
    productDataset() {
      this.updateFilterCountWhenTranslated();
    },
  },
  mounted() {
    // NOSONAR
    this.$nextTick(() => {
      this.activeSection = this.$refs[`section-${this.index}`][0];
      this.activeTrigger = this.$refs[`trigger-${this.index}`][0];
      this.activeCollapsable = this.$refs[`collapsable-${this.index}`][0];
    });

    if (window.eventBus) {
      /* istanbul ignore next */
      window.eventBus.$on('sidebarFilter.toggled', (value) => {
        this.sidebarFilterShown = value;
        /* delay a little bit to switch filter-header from position abs to fixed */
        setTimeout(() => {
          // this.filterHeaderFixed = value
          if (
            document.querySelector('.cookieban') != null &&
            document.querySelector('.sidebar-wrapper-filter.toggled') != null
          ) {
            document.querySelector('.sidebar-wrapper-filter.toggled').style.position = 'absolute';
            document.querySelector('.sidebar-wrapper-filter.toggled').style.top =
              'calc(-100% - 52px)';
          }
        }, 400);
      });

      /* istanbul ignore next */
      window.eventBus.$on('mediaquery.changed', () => {
        this.smallScreen = window.ScreenSizeHandler
          ? window.ScreenSizeHandler.getMqForSize('small').selected
          : true;
      });

      /* istanbul ignore next */
      window.eventBus.$on('datasGrid.updated', () => {
        setTimeout(() => {
          const filterElement = document.getElementsByClassName('is-ref-tag-attributes')[0];
          if (filterElement) {
            const filterSelectedTracking = JSON.parse(filterElement.outerText);
            try {
              dataLayer.push({
                event: 'uaevent',
                event_name: 'use_filters',
                ecommerce: 'undefined',
                eventCategory: 'product selector page',
                eventAction: 'filter',
                eventLabel: filterElement.getAttribute('data-title')
                  ? filterElement.getAttribute('data-title').toLowerCase()
                  : 'none',
                filter_type: 'filter',
                filter_value: filterElement.getAttribute('data-title')
                  ? `${filterElement.getAttribute('data-title').toLowerCase()}::${filterSelectedTracking.filtertitle.toLowerCase()}`
                  : 'none',
              });
            } catch {
              console.warn('datalayer is not defined');
            }
          }
        }, 1000);
      });
    }
  },
  methods: {
    handleClick(index) {
      this.index = index;
      const section = this.$refs[`section-${index}`][0];

      const isVisible = !section.classList.contains('filter-section--hidden');
      isVisible ? this.hide() : this.reveal();
    },

    handleFocus(index) {
      this.index = index;
      this.$refs[`trigger-${index}`][0].addEventListener('keydown', this.handleKeyboard);
    },

    handleFocusOut(index) {
      this.index = index;
      this.$refs[`trigger-${index}`][0].removeEventListener('keydown', this.handleKeyboard);
    },

    handleKeyboard(e) {
      if (e.code === 'Space' || e.code === 'Enter') {
        this.handleClick(this.index);
      }
    },

    reveal() {
      this.activeSection = this.$refs[`section-${this.index}`][0];
      this.activeTrigger = this.$refs[`trigger-${this.index}`][0];
      this.activeCollapsable = this.$refs[`collapsable-${this.index}`][0];

      this.activeSection.classList.remove('filter-section--hidden');
      this.activeTrigger.setAttribute('aria-expanded', 'true');
      this.activeCollapsable.setAttribute('aria-hidden', 'false');

      if (window.eventBus) {
        window.eventBus.$emit('filter::resize');
      }
    },

    hide() {
      this.activeSection = this.$refs[`section-${this.index}`][0];
      this.activeTrigger = this.$refs[`trigger-${this.index}`][0];
      this.activeCollapsable = this.$refs[`collapsable-${this.index}`][0];

      this.activeSection.classList.add('filter-section--hidden');
      this.activeTrigger.setAttribute('aria-expanded', 'false');
      this.activeCollapsable.setAttribute('aria-hidden', 'true');

      if (window.eventBus) {
        window.eventBus.$emit('filter::resize');
      }
    },

    makeJsonFromTaggingString(str) {
      return JSON.parse(str.replace(/=/g, '"'));
    },
    filterProducts(apiUrl, pushState = false) {
      /* istanbul ignore next */
      window.eventBus.$emit('lazy-image-disable');
      this.$parent.getData(apiUrl, pushState);
      this.$parent.scrollUp();
      if (window.eventBus) {
        /* istanbul ignore next */
        window.eventBus.$emit('filter::resize');
        window.eventBus.$emit('on-filter-update');
      }
    },

    openSidebarFilter() {
      if (window.eventBus) {
        window.eventBus.$emit('sidebarFilter.toggled', true);
      }
    },

    closeSidebarFilter() {
      if (window.eventBus) {
        window.eventBus.$emit('sidebarFilter.toggled', false);
      }
    },

    sendDataTrackingAjax() {
      if (document.querySelector('.is-ref-tag-attributes')) {
        document.querySelector('.is-ref-tag-attributes').classList.remove('is-ref-tag-attributes');
      }
    },

    clearUrlToShowForClearBtn(url) {
      const urlToShow = url.substring(4, url.length - 6);
      return urlToShow;
    },

    updateFilterCountWhenTranslated() {
      setTimeout(() => {
        const expectedFilterCount = `(${this.productDataset.results})`;
        const filterCountEl = document.querySelectorAll('.filter-results-count');

        if (filterCountEl[0].textContent !== expectedFilterCount) {
          filterCountEl.forEach((el) => {
            el.textContent = expectedFilterCount;
          });
        }
      }, 100);
    },
  },
};
</script>
